import React from "react";
import { Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import DownloadTemplates from "./DownloadTemplates";

import "./Audit.css";

const Audit = (props) => {
  const { user } = props;

  // const Json = ({ data }) => <pre>{JSON.stringify(data, null, 4)}</pre>;

  return (
    <div className="Audit">
      <Card>
        <CardHeader tag="h5" className="bg-light text-dark font-weight-bold">
          Auditor
        </CardHeader>
        <CardBody>
          <CardTitle>{user.name}, you are logged on as auditor.</CardTitle>
          {/* <Json data={user} /> */}
        </CardBody>
      </Card>
      {user.prefs.fileTypes && user.prefs.fileTypes.length ? (
        <DownloadTemplates
          params={{ role: user.role, fileTypes: user.prefs.fileTypes }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Audit;
